import '@/css/_student-team.js'

// src/js/yourteam.js
import Swiper from 'swiper';
import { Parallax, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/parallax';

// Initialize the thumbnail swiper first
// const thumbsSwiper = new Swiper('.thumbs-swiper', {
//     spaceBetween: 10,
//     slidesPerView: 10,  // Adjust based on your layout
//     // freeMode: true,
//     centeredSlides: false,
//     watchSlidesProgress: true,
// });



// Initialize the main swiper with all features
const mainSwiper = new Swiper('.main-swiper', {
    modules: [Parallax, EffectFade],
    initialSlide: 0,
    // Fade effect
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },

    // Thumbs (gallery thumbs)
    // thumbs: {
    //     swiper: thumbsSwiper,
    // },

    // Parallax effects (apply data-swiper-parallax attributes to child elements)
    parallax: true,

    // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },

    // Additional options (customize as needed)
    speed: 800,  // Transition speed in ms
    loop: false,  // Infinite loop (optional, but recommended for fade/parallax)
    autoHeight: true,
    simulateTouch: false,

    on: {
        init: function () {
            console.log('swiper initialized');
        },
    },
});


// const btns = document.querySelectorAll('.click-button');
const navBtns = document.querySelectorAll('.js-btn');
const arrowBack = document.querySelector('.nav__arrow-back');
const arrowBackBtn = document.querySelectorAll('.js-arrow-back');
const roll = document.querySelectorAll('.stat');
const coreTeam = document.querySelectorAll('[data-subteam="core"]');
const fullTeam = document.querySelectorAll('[data-team="full"]');
const heroTitle = document.querySelector('.student-team_hero');
// const dataId = document.querySelectorAll('[data-id]').getAttribute('data-id');
console.log(coreTeam);
// btns.forEach((button)  => {
//     const dataId = button.dataset.id;
//     button.addEventListener('click', function () {
//         console.log(button);
//         console.log(dataId);
//         mainSwiper.slideTo(dataId);
//     })
// })
// slideChange events
navBtns.forEach((button)  => {
    const dataId = button.dataset.id;
    button.addEventListener('click', function () {
        console.log(button);
        console.log(dataId);
        mainSwiper.slideTo(dataId);
    })
})

// event arrowBack
arrowBackBtn.forEach((backBtn)  => {
console.log(backBtn);
    backBtn.addEventListener('click', function () {
        mainSwiper.slideTo(0);
    })
})
// slideChange events
mainSwiper.on('slideChange', function () {
    console.log(mainSwiper);
    if(mainSwiper.activeIndex !== 0) {
        // console.log(this.slides[this.activeIndex]);
        // console.log(this.activeIndex)
        console.log(mainSwiper.activeIndex)
        const activeSlide = this.slides[this.activeIndex];
        const targetId = this.activeIndex; // assuming data-id matches slide index

        // const slideActive = document.querySelector(".swiper-slide-active");
        const statElement = activeSlide.querySelector(`.js-stat[data-id="${targetId}"]`);
        console.log(statElement);
        statElement.classList.add('active');

        // if (slideActive) {
        //     slideActive.classList.add('limit-height');
        // } else {
        //     slideActive.classList.remove('limit-height');
        // }
    }
    // const slideActive = document.querySelector(".swiper-slide-active")
    if(mainSwiper.activeIndex !== 0) {
        heroTitle.classList.add('slide-active');
        arrowBack.classList.remove('visually-hidden');
    } else {
        heroTitle.classList.remove('slide-active');
        arrowBack.classList.add('visually-hidden');
    }
    // Remove custom class from all slides first (safe)
    this.slides.forEach(slide => slide.classList.remove('limit-height'));

    if (this.activeIndex !== 0) {
        // this.realIndex if you use loop: true and want the original index
        this.slides[this.activeIndex].classList.add('limit-height');
    }

    this.el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });

})
// fullTeam.forEach((full)  => {
//     mainSwiper.on("slideChange", function () {
//         moveElement.classList.add('move-in');
//     })
//     mainSwiper.on("slideChangeTransitionEnd", function () {
//         moveElement.classList.remove('move-in','move-out');
//     })
// })
// const tooltips = document.querySelectorAll(".tooltip");
//
// function tooltipListeners(i) {
//     btns[i].addEventListener("mouseover", () => {
//         tooltips[i].showPopover({ source: btns[i] });
//     });
//
//     btns[i].addEventListener("mouseout", () => {
//         tooltips[i].hidePopover();
//     });
//
//     btns[i].addEventListener("focus", () => {
//         tooltips[i].showPopover({ source: btns[i] });
//     });
//
//     btns[i].addEventListener("blur", () => {
//         tooltips[i].hidePopover();
//     });
// }
//
// for (let i = 0; i < btns.length; i++) {
//     tooltipListeners(i);
// }

// const handleClick = (e) => {
//     if (e.target.classList.contains('swiper-no-swiping')) {
//         e.stopPropagation();
//     }
// };

// tooltips.forEach((tooltip)  => {
//     console.log(tooltip);
//     tooltip.addEventListener('click', function (e){
//         console.log(e.target.classList.contains('swiper-no-swiping'));
//         if (e.target.classList.contains('swiper-no-swiping')) {
//             e.stopPropagation();
//         }
//     });
// });
const popover = document.querySelectorAll(".popover-btn");
const popoverClose = document.querySelectorAll(".popover-close");

popover.forEach(popover => {
    popover.addEventListener('click', function (e) {
        console.log(e.target);
        console.log(e.target.classList.contains('swiper-no-swiping'));
        if (e.target.classList.contains('swiper-no-swiping')) {
            e.stopPropagation();
        }
        popover.parentNode.parentNode.parentNode.classList.add('popover-active');
    })
})
popoverClose.forEach((close) => {
    close.addEventListener('click', function (e) {
        console.log(close);
        popover.forEach(popover => {
            popover.parentNode.parentNode.parentNode.classList.remove('popover-active');
        })
    })
})

console.log(mainSwiper);

console.log(arrowBack);
